module.exports = __webpack_public_path__ + "img/LetzterAbend.76fed6ea.jpg";